import {GetParticipationApiResponse} from '@dms/api/shared';

export type AssignmentSelection = {
  value: string[] | string | null;
  type: keyof GetParticipationApiResponse;
};
